import React, { useEffect } from 'react';
import T from 'prop-types';
import { useDispatch } from 'react-redux';

import MarketOverview from '../components/MarketOverview';
import TrendsSummary from '../components/TrendsSummary';
import TimeSpentPenetration from '../components/TsPenetration';
import MarketBehavior from '../components/MarketBehavior';
import AppImpact from '../components/AppImpact';
import FullAccessBanner from '../components/FullAccessBanner';
import SectorsStats from '../components/SectorsStats';
import AppTrends from '../components/AppTrends';
import AiStickyHeader from '../components/AiStickyHeader';
import TabExportButton from '../components/TabExportButton';
import AiDashboardStaticView from '../components/AiDashboardStaticView';
import PreviewTopBanner from '../components/PreviewTopBanner';
import PreviewBottomSection from '../components/PreviewBottomSection';
import { DashboardTabNavigation } from '../../_shared/components/DashboardTabNavigation';
import { useStickySentinel } from '../../_shared/components/DashboardStickyHeader';
import { scrollToSection } from '../../_shared/hooks/useDashboardNav';
import Container from '../../../../components/Container';
import { fetchAiDashboardData } from '../actions';
import { SECTIONS, SECTIONS_IDS } from '../configs/sections';

const AiDashboardContainer = ({
  isPublic = false,
  campaignEnded = false,
  showAiBanner = false,
  isPress = false,
}) => {
  const dispatch = useDispatch();

  const { sentinelRef, sentinelNode } = useStickySentinel();

  useEffect(() => {
    dispatch(fetchAiDashboardData({ campaignEnded }));
  }, [dispatch, campaignEnded]);

  return (
    <>
      {(isPublic || showAiBanner) && <PreviewTopBanner campaignEnded={campaignEnded} />}
      <div className="dashboard-tab ai-dashboard-tab">
        <AiStickyHeader stickySentinelRef={sentinelRef} />
        <Container maxWidth={1128}>
          <header className="dashboard-tab-content-header">
            <DashboardTabNavigation sections={SECTIONS} onScrollToSection={scrollToSection} />
            {!isPress && <TabExportButton isPublic={isPublic || campaignEnded} />}
          </header>
          {sentinelNode}
          <div className="dashboard-tab-content">
            {campaignEnded ? (
              <AiDashboardStaticView />
            ) : (
              <>
                <div id={SECTIONS_IDS.marketOverview}>
                  <MarketOverview allowQV={!isPublic && !isPress} isPress={isPress} />
                </div>
                <div className="separator-h" />
                {isPublic && <FullAccessBanner />}
                <div id={SECTIONS_IDS.behavioralTrends}>
                  <TrendsSummary allowQV={!isPublic && !isPress} />
                </div>
                <div id={SECTIONS_IDS.shareOfScreenTime}>
                  <TimeSpentPenetration isPress={isPress} />
                </div>
                <div id={SECTIONS_IDS.marketBehavior}>
                  <MarketBehavior isPress={isPress} />
                </div>
                <div id={SECTIONS_IDS.screenTimeBySector}>
                  <SectorsStats />
                </div>
                <div id={SECTIONS_IDS.appTrends}>
                  <AppTrends isPress={isPress} />
                </div>
                <div id={SECTIONS_IDS.aiAppImpact}>
                  <AppImpact isPublic={isPublic} isPress={isPress} />
                </div>
              </>
            )}
          </div>
        </Container>
      </div>
      {isPublic && <PreviewBottomSection />}
    </>
  );
};

AiDashboardContainer.propTypes = {
  isPublic: T.bool,
  campaignEnded: T.bool,
  showAiBanner: T.bool,
  isPress: T.bool,
};

export default AiDashboardContainer;
